<app-bolt-and-pump-output [calcOutput]="calcOutput" [selectedTool]="selectedTool" (showAdvOptPanel)="showAdvancedOutputpanel()"  [displayIDMSSettings]="displayIDMSSettings"></app-bolt-and-pump-output>
